import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const TermsOfService = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', py: 6 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Terms of Service
          </Typography>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            Welcome to Shoora Welfare. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Use of Website
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            You agree to use this website only for lawful purposes and in a manner that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the website.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Intellectual Property
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            All content on this website, including text, graphics, logos, and images, is the property of Shoora Welfare and is protected by applicable copyright and trademark laws.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Limitation of Liability
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            Shoora Welfare will not be liable for any damages arising from the use or inability to use this website or any information provided on it.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Changes to Terms
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8, color: 'text.primary' }}>
            We reserve the right to update these terms at any time. Any changes will be posted on this page, and your continued use of the website constitutes acceptance of the updated terms.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8, color: 'text.primary' }}>
            If you have any questions about these Terms of Service, please contact us at <strong>shoorawelfare@gmail.com</strong>.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService;
